import { formatAssetStat, round } from './formatValues';

export function getPercent(asset: any) {
  if (!asset) {
    return ''
  }
  const isOpenMarket = asset?.quote?.is_market_open

  // eslint-disable-next-line no-unsafe-optional-chaining
  const latest = Number.isNaN(+asset.latest_price?.price) ? 0 : +asset.latest_price?.price

  // eslint-disable-next-line no-unsafe-optional-chaining
  let oldest = Number.isNaN(+asset.quote?.previous_close) ? 0 : +asset.quote?.previous_close

  if (isOpenMarket === false && typeof asset?.quote?.close === 'number') {
    oldest = Number(asset?.quote?.close);
  }

  if (!oldest || !latest) return 0
  const delta = latest - oldest

  const res = (delta / oldest) * 100

  return `${(res >= 0) ? '+' : '-'} ${(isOpenMarket) ? formatAssetStat(Math.abs(res), true) : formatAssetStat(Math.abs(asset?.quote?.percent_change), true)}`
}

export function getPercentAbs(asset: any) {
  const latest = asset.latest_price?.price || 0
  const oldest = asset.start_day_price?.price || 0
  if (!oldest || !latest) return 0
  const res = round((100 * (latest - oldest)) / oldest)
  return res
}

export const getTradingUrl = (platform, item, isETF) => {
  if (!platform || !item) {
    return ''
  }

  if (item?.trading_platform_link?.[platform?.name]) {
    return item?.trading_platform_link?.[platform?.name]
  }

  return `${platform?.website}${platform?.url_regex.replace('{ticker}', item?.ticker?.toLowerCase()).replace('{register_name}', item?.register_name?.toLowerCase()).replace('{exchange}', isETF ? 'nysearca' : item?.quote?.exchange?.toLowerCase()).replace('{category}', isETF ? 'stocks' : item?.category?.name?.toLowerCase())}`
}
